<template>
  <div class="demo-split IVR_setting" :style="screenHeight">
    <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <div class="demo-split-pane left_tree" style="float:left;border-right:1px solid #eeeeee;width:30%">
        <ul id="IVRTree" class="ztree" style="height: 100%; overflow: auto;"></ul>
      </div>
      <div class="demo-split-pane" style="float:right;width:70%">
        <div class="demo_title">{{demoTitle}}</div>
        <!--顶级菜单编辑-->
        <div class="middle_content" :style="demoHeight" v-if="showPageByIvrType=='0'">
          <div class="input_overall">
            <div class="font_style_set">IVR名称:</div>
            <Input v-model="ivrName" />
          </div>
          <div class="input_overall">
            <div class="font_style_set"><span v-if="ivrType=='1'" style="color: red">*</span>欢迎词类型:</div>
            <Select v-model="voiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl"  v-if="voiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="欢迎词语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>
          </div>
          <div v-if="ivrType=='2'">
            <div class="input_overall">
              <div class="font_style_set">开始转接时间(秒):</div>
              <Input v-model="startTransferTime" placeholder="开始转接时间"/>
              <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
            </div>
            <div class="input_overall">
              <div class="font_style_set">业务类型:</div>
              <Select v-model="businessType">
                <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
                <div slot="content">
                  多个号码填写时以“,”作为间隔<br/>
                  顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
                  记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
                  共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
                  技能组：将呼入号码转接至所选技能组中<br/>
                </div>
              </Tooltip>
            </div>
            <div class="input_overall" v-if="businessType!='9'">
              <div class="font_style_set"><span style="color: red">*</span>号码:</div>
              <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
              <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
            </div>
            <div class="input_overall" v-if="businessType=='9'">
              <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
              <Select v-model="transNumber">
                <OptionGroup label="普通技能组">
                  <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
                </OptionGroup>
                <OptionGroup label="AI技能组">
                  <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
                </OptionGroup>
              </Select>
            </div>
          </div>
          <div v-else>
            <div class="input_overall">
              <div class="font_style_set">可选设置:</div>
              <Checkbox v-model="highSet">高级设置</Checkbox>
              <Checkbox v-model="isCallExtension" v-if="highSet">允许拨打分机</Checkbox>
              <Checkbox v-model="isTimeoutBusiness" v-if="highSet">启用超时业务</Checkbox>
            </div>
            <div class="input_overall" v-if="highSet">
              <div class="font_style_set">短欢迎词类型:</div>
              <Select v-model="shortVoiceType">
                <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <Upload :action="uploadUrl" v-if="shortVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessShortVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
                <img src="../../../assets/image/upload.png" title="短欢迎词语音文件上传">
              </Upload>
              <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(shortVoiceFile)"></div>
            </div>
            <div class="input_overall" v-if="highSet">
              <div class="font_style_set">无效提示音类型:</div>
              <Select v-model="invalidVoiceType">
                <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <Upload :action="uploadUrl" v-if="invalidVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessInvalidVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
                <img src="../../../assets/image/upload.png" title="无效提示音文件上传">
              </Upload>
              <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(invalidVoiceFile)"></div>
            </div>
            <div class="input_overall" v-if="highSet">
              <div class="font_style_set">超过重复提示次数提示音类型:</div>
              <Select v-model="exceedVoiceType">
                <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <Upload :action="uploadUrl" v-if="exceedVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessExceedVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
                <img src="../../../assets/image/upload.png" title="超次语音文件上传">
              </Upload>
              <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(exceedVoiceFile)"></div>
            </div>
            <div class="input_overall" v-if="highSet">
              <div class="font_style_set">记忆功能:</div>
              <RadioGroup v-model="memoryType" type="button">
                <Radio v-for="(option, index) in memoryList" :label="option.id" :key="index">{{option.name}}</Radio>
              </RadioGroup>
            </div>
            <div class="input_overall" v-if="highSet && memoryType!='0'">
              <div class="font_style_set"><span style="color: red">*</span>记忆时间(分钟数):</div>
              <Input v-model="memoryDuration" placeholder="请输入记忆时间(分钟数)"/>
              <Tooltip class="tips_font" placement="top" content="1-50000"><img :src="questionMark"/></Tooltip>
            </div>
            <div class="input_overall" v-if="highSet && !isTimeoutBusiness">
              <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
              <Input v-model="promptInterval" placeholder="请输入重复提示间隔(秒)"/>
            </div>
            <div class="input_overall" v-if="highSet && !isTimeoutBusiness">
              <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
              <Input v-model="promptCount" placeholder="请输入重复提示次数"/>
            </div>
            <div class="input_overall" v-if="highSet && isTimeoutBusiness">
              <div class="font_style_set">超时时间(秒):</div>
              <Input v-model="timeout" @on-blur="checkPhoneNumber"/>
              <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
            </div>
            <div class="input_overall" v-if="highSet && isTimeoutBusiness">
              <div class="font_style_set">业务类型:</div>
              <Select v-model="businessType">
                <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
              </Select>
              <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
                <div slot="content">
                  多个号码填写时以“,”作为间隔<br/>
                  顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
                  记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
                  共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
                  技能组：将呼入号码转接至所选技能组中<br/>
                </div>
              </Tooltip>
            </div>
            <div class="input_overall" v-if="highSet && isTimeoutBusiness && businessType!='9'">
              <div class="font_style_set"><span style="color: red">*</span>号码:</div>
              <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔" :autosize="autoSize" type="textarea"/>
              <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
            </div>
            <div class="input_overall" v-if="highSet && isTimeoutBusiness && businessType=='9'">
              <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
              <Select v-model="transNumber">
                <OptionGroup label="普通技能组">
                  <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
                </OptionGroup>
                <OptionGroup label="AI技能组">
                  <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
                </OptionGroup>
              </Select>
            </div>
          </div>
        </div>
        <!--下级菜单新增-->
        <div class="middle_content" :style="demoHeight" v-if="showPageByIvrType=='1'">
          <div class="input_overall">
            <div class="font_style_set">IVR名称:</div>
            <Input v-model="ivrName" readonly/>
          </div>
          <div class="input_overall">
            <div class="font_style_set">根节点:</div>
            <Input v-model="pidName" readonly/>
          </div>
          <div class="input_overall">
            <div class="font_style_set">IVR类型:</div>
            <Select v-model="ivrType" placeholder="下级菜单" @on-change="changeVoiceType">
              <Option v-for="(option, index) in IVRTypeList" :value="option.id" :disabled="option.id=='3'&&pid=='0'" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">功能按键:</div>
            <Select v-model="funcKey" placeholder="功能按键">
              <Option v-for="(option, index) in keyCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall" v-if="ivrType=='1' || ivrType=='2'">
            <div class="font_style_set"><span v-if="ivrType=='1'" style="color: red">*</span>语音类型:</div>
            <Select v-model="voiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl"  v-if="voiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="欢迎词语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>
          </div>
          <div class="input_overall">
            <div class="font_style_set">可选设置:</div>
            <Checkbox v-model="highSet">高级设置</Checkbox>
            <Checkbox v-model="isSendSms" v-if="highSet">发送短信</Checkbox>
            <Checkbox v-model="isSmsGather" v-if="highSet">按键采集</Checkbox>
            <Checkbox v-model="isCallExtension" v-if="highSet && ivrType=='1'">允许拨打分机</Checkbox>
            <Checkbox v-model="isTimeoutBusiness" v-if="highSet && ivrType=='1'">启用超时业务</Checkbox>
          </div>
          <div class="input_overall" v-if="highSet && !isTimeoutBusiness && ivrType=='1'">
            <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
            <Input v-model="promptInterval" placeholder="请输入重复提示间隔(秒)"/>
          </div>
          <div class="input_overall" v-if="highSet && !isTimeoutBusiness && ivrType=='1'">
            <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
            <Input v-model="promptCount" placeholder="请输入重复提示次数"/>
          </div>
          <div class="input_overall" v-if="highSet && isTimeoutBusiness">
            <div class="font_style_set">超时时间(秒):</div>
            <Input v-model="timeout" @on-blur="checkPhoneNumber"/>
            <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="ivrType=='2'">
            <div class="font_style_set">开始转接时间(秒):</div>
            <Input v-model="startTransferTime" placeholder="开始转接时间"/>
            <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="(highSet && isTimeoutBusiness) || ivrType=='2'">
            <div class="font_style_set">业务类型:</div>
            <Select v-model="businessType">
              <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
              <div slot="content">
                多个号码填写时以“,”作为间隔<br/>
                顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
                记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
                共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
                技能组：将呼入号码转接至所选技能组中<br/>
              </div>
            </Tooltip>
          </div>
          <div class="input_overall" v-if="(highSet && isTimeoutBusiness && businessType!='9') || (businessType!='9' && ivrType=='2')">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔"/>
            <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="(highSet && isTimeoutBusiness && businessType=='9') || (businessType=='9' && ivrType=='2')">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <Select v-model="transNumber">
              <OptionGroup label="普通技能组">
                <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
              </OptionGroup>
              <OptionGroup label="AI技能组">
                <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
              </OptionGroup>
            </Select>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather">
            <div class="font_style_set">按键描述:</div>
            <Input v-model="smsButtonDesc" placeholder="请输入按键描述"/>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather && (ivrType=='1' || ivrType=='4')">
            <div class="font_style_set">按键长度:</div>
            <Input v-model="gatherLength" @on-blur="checkPhoneNumber" placeholder="请输入按键长度"/>
          </div>
          <div class="input_overall" v-show="highSet && isSmsGather && (ivrType=='1' || ivrType=='4')">
            <div class="font_style_set">按键语音类型:</div>
            <Select v-model="gatherVoiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl" v-if="gatherVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleBtnVoiceFile" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="按键语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(btnVoiceFile)"></div>
          </div>
          <div class="input_overall" v-if="highSet && isSendSms">
            <div class="font_style_set">短信内容:</div>
            <Input v-model="smsContent" :autosize="autoSize" type="textarea"/>
            <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
          </div>
        </div>
        <!--转接电话编辑-->
        <div class="middle_content" :style="demoHeight" v-if="showPageByIvrType=='2'">
          <div class="input_overall">
            <div class="font_style_set">IVR类型:</div>
            <Select v-model="ivrType" placeholder="下级菜单" disabled @on-change="changeVoiceType">
              <Option v-for="(option, index) in IVRTypeList" :value="option.id" :disabled="option.id=='3'" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">功能按键:</div>
            <Select v-model="funcKey" placeholder="功能按键">
              <Option v-for="(option, index) in keyCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">业务类型:</div>
            <Select v-model="businessType">
              <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
              <div slot="content">
                多个号码填写时以“,”作为间隔<br/>
                顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
                记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
                共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
                技能组：将呼入号码转接至所选技能组中<br/>
              </div>
            </Tooltip>
          </div>
          <div class="input_overall" v-if="businessType!='9'">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔"/>
            <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="businessType=='9'">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <Select v-model="transNumber">
              <OptionGroup label="普通技能组">
                <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
              </OptionGroup>
              <OptionGroup label="AI技能组">
                <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
              </OptionGroup>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">可选设置:</div>
            <Checkbox v-model="highSet">高级设置</Checkbox>
            <Checkbox v-model="isSendSms" v-if="highSet">发送短信</Checkbox>
            <Checkbox v-model="isSmsGather" v-if="highSet">按键采集</Checkbox>
          </div>
          <div class="input_overall" v-if="highSet">
            <div class="font_style_set">欢迎词类型:</div>
            <Select v-model="voiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl"  v-if="voiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="欢迎词语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>
          </div>
          <div class="input_overall" v-if="highSet">
            <div class="font_style_set">开始转接时间(秒):</div>
            <Input v-model="startTransferTime" placeholder="开始转接时间"/>
            <Tooltip class="tips_font" placement="top" content="0-60秒"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="highSet && isSendSms">
            <div class="font_style_set">短信内容:</div>
            <Input v-model="smsContent" :autosize="autoSize" type="textarea"/>
            <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather">
            <div class="font_style_set">按键描述:</div>
            <Input v-model="smsButtonDesc" placeholder="请输入按键描述"/>
          </div>
        </div>
        <!--返回上级菜单与返回顶级菜单的编辑-->
        <div class="middle_content" :style="demoHeight" v-if="showPageByIvrType=='3' || showPageByIvrType=='4'">
          <div class="input_overall">
            <div class="font_style_set">IVR类型:</div>
            <Select v-model="ivrType" placeholder="下级菜单" disabled @on-change="changeVoiceType">
              <Option v-for="(option, index) in IVRTypeList" :value="option.id" :disabled="option.id=='3'" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">功能按键:</div>
            <Select v-model="funcKey" placeholder="功能按键">
              <Option v-for="(option, index) in keyCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">可选设置:</div>
            <Checkbox v-model="highSet">高级设置</Checkbox>
            <Checkbox v-model="isSendSms" v-if="highSet">发送短信</Checkbox>
            <Checkbox v-model="isSmsGather" v-if="highSet">按键采集</Checkbox>
          </div>
          <!--<div class="input_overall" v-if="highSet">-->
            <!--<div class="font_style_set">超时时间(秒):</div>-->
            <!--<Input v-model="timeout"/>-->
            <!--<Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>-->
          <!--</div>-->
          <div class="input_overall" v-if="highSet && isSendSms">
            <div class="font_style_set">短信内容:</div>
            <Input v-model="smsContent" :autosize="autoSize" type="textarea"/>
            <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather">
            <div class="font_style_set">按键描述:</div>
            <Input v-model="smsButtonDesc" placeholder="请输入按键描述"/>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather && showPageByIvrType=='4'">
            <div class="font_style_set">按键长度:</div>
            <Input v-model="gatherLength" @on-blur="checkPhoneNumber" placeholder="请输入按键长度"/>
          </div>
          <div class="input_overall" v-show="highSet && isSmsGather && showPageByIvrType=='4'">
            <div class="font_style_set">按键语音类型:</div>
            <Select v-model="gatherVoiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl" v-if="gatherVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleBtnVoiceFile" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="按键语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(btnVoiceFile)"></div>
          </div>
        </div>
        <!--子级菜单编辑-->
        <div class="middle_content" :style="demoHeight" v-if="showPageByIvrType=='5'">
          <div class="input_overall">
            <div class="font_style_set">IVR类型:</div>
            <Select v-model="ivrType" placeholder="下级菜单" disabled @on-change="changeVoiceType">
              <Option v-for="(option, index) in IVRTypeList" :value="option.id" :disabled="option.id=='3'" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">功能按键:</div>
            <Select v-model="funcKey" placeholder="功能按键">
              <Option v-for="(option, index) in keyCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </div>
          <div class="input_overall">
            <div class="font_style_set">可选设置:</div>
            <Checkbox v-model="highSet">高级设置</Checkbox>
            <Checkbox v-model="isSendSms" v-if="highSet">发送短信</Checkbox>
            <Checkbox v-model="isSmsGather" v-if="highSet">按键采集</Checkbox>
            <Checkbox v-model="isCallExtension" v-if="highSet && ivrType=='1'">允许拨打分机</Checkbox>
            <Checkbox v-model="isTimeoutBusiness" v-if="highSet && ivrType=='1'">启用超时业务</Checkbox>
          </div>
          <div class="input_overall" v-if="highSet">
            <div class="font_style_set"><span style="color: red">*</span>语音类型:</div>
            <Select v-model="voiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl"  v-if="voiceType=='1'" :show-upload-list="showUploadList" :on-success="handleSuccessVoiceType" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="欢迎词语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(voiceFile)"></div>
          </div>
          <div class="input_overall" v-if="highSet && !isTimeoutBusiness">
            <div class="font_style_set"><span style="color: red">*</span>重复提示间隔(秒):</div>
            <Input v-model="promptInterval" placeholder="请输入重复提示间隔(秒)"/>
          </div>
          <div class="input_overall" v-if="highSet && !isTimeoutBusiness">
            <div class="font_style_set"><span style="color: red">*</span>重复提示次数:</div>
            <Input v-model="promptCount" placeholder="请输入重复提示间隔次数"/>
          </div>
          <div class="input_overall" v-if="highSet && isTimeoutBusiness">
            <div class="font_style_set">超时时间(秒):</div>
            <Input v-model="timeout" @on-blur="checkPhoneNumber"/>
            <Tooltip class="tips_font" placement="top" content="(0-60)*"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="highSet && isTimeoutBusiness">
            <div class="font_style_set">业务类型:</div>
            <Select v-model="businessType">
              <Option v-for="(option, index) in businessList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Tooltip class="tips_font" placement="top"><img :src="questionMark"/>
              <div slot="content">
                多个号码填写时以“,”作为间隔<br/>
                顺振: 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入共振流程时都将从位置1号码开始呼叫<br/>
                记忆轮循： 对所填写的号码按先后顺序进行呼叫，若都未接通将会挂断。每次进入记忆轮循流程时将从上一次被呼叫号码后的号码开始呼叫<br/>
                共振：每次呼入时将同时呼叫所填号码，其中任意一个号码接通后对于其余号码的呼叫将会停止。<br/>
                技能组：将呼入号码转接至所选技能组中<br/>
              </div>
            </Tooltip>
          </div>
          <div class="input_overall" v-if="(highSet && isTimeoutBusiness && businessType!='9') || ivrType=='2'">
            <div class="font_style_set"><span style="color: red">*</span>号码:</div>
            <Input v-model="transNumber" placeholder="号码之间用英文逗号相隔"/>
            <Tooltip class="tips_font" placement="top" content="填分机号,外线号码;号码之间用英文逗号相隔;号码最多可以填三个"><img :src="questionMark"/></Tooltip>
          </div>
          <div class="input_overall" v-if="(highSet && isTimeoutBusiness && businessType=='9') || (businessType=='9' && ivrType=='2')">
            <div class="font_style_set"><span style="color: red">*</span>技能组号码:</div>
            <Select v-model="transNumber">
              <OptionGroup label="普通技能组">
                <Option v-for="(option, index) in queueList" :value="option.queueNum" :key="`normal`+index">{{option.queueName}}</Option>
              </OptionGroup>
              <OptionGroup label="AI技能组">
                <Option v-for="(option, index) in queueList2" :value="option.queueNum" :key="`ai`+index">{{option.queueName}}</Option>
              </OptionGroup>
            </Select>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather">
            <div class="font_style_set">按键描述:</div>
            <Input v-model="smsButtonDesc" placeholder="请输入按键描述"/>
          </div>
          <div class="input_overall" v-if="highSet && isSmsGather">
            <div class="font_style_set">按键长度:</div>
            <Input v-model="gatherLength" @on-blur="checkPhoneNumber" placeholder="请输入按键长度"/>
          </div>
          <div class="input_overall" v-show="highSet && isSmsGather">
            <div class="font_style_set">按键语音类型:</div>
            <Select v-model="gatherVoiceType">
              <Option v-for="(option, index) in welCodeList" :value="option.id" :key="index">{{option.name}}</Option>
            </Select>
            <Upload :action="uploadUrl" v-if="gatherVoiceType=='1'" :show-upload-list="showUploadList" :on-success="handleBtnVoiceFile" :on-error="handleFail" :format="format" :max-size="1024*1024*15">
              <img src="../../../assets/image/upload.png" title="按键语音文件上传">
            </Upload>
            <div class="img_div"><img src="../../../assets/image/audition.png" title="试听"  @click="playVoiceFile(btnVoiceFile)"></div>
          </div>
          <div class="input_overall" v-if="highSet && isSendSms">
            <div class="font_style_set">短信内容:</div>
            <Input v-model="smsContent" :autosize="autoSize" type="textarea"/>
            <Tooltip class="tips_font" placement="top" content="内容允许空格，但不允许换行"><img :src="questionMark"/></Tooltip>
          </div>
        </div>
        <div class="input_overall IVR_btn">
          <Button type="info" long style="font-size: 18px" @click="save">保 存</Button>
          <Button type="success" long style="font-size: 18px" @click="getBack">返 回</Button>
        </div>
        <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
      </div>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
    export default {
      name: "IVRSetting",
      mixins:[publicFunClass],
      props:{
        Id:String,
        name:String,
        rootName:String,
        ivrTableType:String
      },
      components:{
        playMusicPop
      },
      data () {
        return {
          model:false,
          treeId:'',
          spinShow:true,
          split: 0.3,
          showRecordFile:false,
          screenHeight:{height:''},
          demoHeight:{height:''},
          recordFile:'',
          questionMark:require('../../../assets/image/homeAsk.png'),
          autoSize:true,
          showUploadList:false,
          count:0,
          format:['mp3','wav'],
          inspectTreeData:[],
          demoTitle:'编辑IVR语音导航',
          IVRTypeList:[{id:'1', name:"下级菜单"},{id:'2', name:"转接电话"},{id:'3', name:"返回上级菜单"},{id:'4', name:"返回顶级菜单"}],
          keyCodeList:[{id:'0', name:"0"},{id:'1', name:"1"},{id:'2', name:"2"},{id:'3', name:"3"},{id:'4', name:"4"},{id:'5', name:"5"},{id:'6', name:"6"},{id:'7', name:"7"},{id:'8', name:"8"},{id:'9', name:"9"},{id:'*', name:"*"}],
          optionalList:[{id:'1', name:"高级设置"},{id:'2', name:"发送短信"},{id:'3', name:"按键采集"},{id:'4', name:"允许拨打分机"},{id:'5', name:"启用超时业务"}],
          welCodeList:[{id:'1', name:"语音文件"}],
          businessList:[{id:'1', name:"顺振"},{id:'2', name:"记忆轮循"},{id:'3', name:"共振"},{id:'9', name:"技能组"}],
          ivrName:'',
          pidName:'',
          showPageByIvrType:'0',
          pid:'',
          gatherVoiceType:'1',
          btnVoiceFile:'',
          smsContent:'',
          smsButtonDesc:'',
          gatherLength:'',
          ivrType:'1',
          funcKey:'0',
          voiceType:'1',
          voiceFile:'',
          highSet:false,
          isSendSms:false,
          isSmsGather:false,
          isCallExtension:false,
          isTimeoutBusiness:false,
          uploadUrl:this.baseURL+"common/upload.json?type=customizeMusic&companyNo="+localStorage.getItem("companyId"),
          promptInterval:'3',
          promptCount:'3',
          exceedVoiceFile:'',
          memoryType:'0',
          memoryDuration:'',
          timeout:"20",
          transNumber:'',
          startTransferTime:'0',
          businessType:'9',
          queueList:[],
          queueList2:[],
          editOrAdd:'2',
          nodeId:'',
          exceedVoiceType:'',
          invalidVoiceType:'',
          shortVoiceType:'',
          memoryList:[{id:'0', name:"关闭"},{id:'1', name:"呼出未接记录记忆"},{id:'2', name:"全部记录记忆"}]
        }
      },
      methods:{
        checkPhoneNumber:function(event){
          let name=event.currentTarget.name;
          let value=event.currentTarget.value;
          let reg=/^[0-9]*$/;
          if(!reg.test(value)){
            this.$Modal.info({
              title:'提示',
              content:name+"只能输入数字"
            });
            event.currentTarget.value=event.currentTarget.value.replace(/[^\d]/g,'');
            return false;
          }
        },
        changeVoiceType:function(){
          this.highSet=false;
          this.isSendSms=false;
          this.isSmsGather=false;
          this.isCallExtension=false;
          this.isTimeoutBusiness=false;
        },
        handleSuccessVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.voiceFile=file.response.obj.absolutePath;
        },
        handleBtnVoiceFile:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.btnVoiceFile=file.response.obj.absolutePath;
        },
        handleFail:function (error, file) {
          this.$Modal.info({
            title:'失败提示',
            content:file.response.msg
          });
        },
        getBack:function(){
          this.$emit("closeIvrSetting",false)
        },
        save:function(){
          let url='';
          let pId="";
          let ivrId="";
          if(this.pid!='0' && this.editOrAdd=='2'){
            url='ivr/updateIvrDetail.json';
            pId=this.pid;
            ivrId=this.nodeId;
          }
          if(this.editOrAdd=='1'){
            url='ivr/insertIvrDetail.json';
            pId=this.nodeId;
            ivrId=this.Id;
          }
          let time = '';
          if(this.ivrType=='1'){
            time = this.timeout;
          }
          if(this.ivrType=='2'){
            time = this.startTransferTime;
          }
          if(this.ivrType=='1' && this.memoryType!="0" && (this.memoryDuration>50000 || this.memoryDuration<1)){
            this.$Message.info("记忆时间必须在1到50000分钟之内");
            return false;
          }
          let that=this;
          let param={
            ivrId:ivrId,
            pid:pId,
            funcKey:this.funcKey,
            ivrType:this.ivrType,
            voiceType:this.voiceType,
            voiceFile:this.voiceFile,
            isSendSms:this.isSendSms?'1':'0',
            smsContent:this.smsContent,
            isSmsGather:this.isSmsGather?'1':'0',
            gatherVoiceType:this.gatherVoiceType,
            smsButtonDesc:this.smsButtonDesc,
            gatherLength:this.gatherLength,
            gatherVoiceFile:this.btnVoiceFile,
            isTimeoutBusiness:this.isTimeoutBusiness?'1':'0',
            timeout:time,
            businessType:this.businessType,
            transNumber:this.transNumber,
            promptInterval:this.promptInterval,
            promptCount:this.promptCount,
            isCallExtension:this.isCallExtension?'1':'0',
            highSet:this.highSet?'1':'0'
          }
          let flag=false;
          if(this.pid=='0' && this.editOrAdd=='2'){
            param={
              journalType:"CTI配置=>IVR配置=>编辑",
              menuId:"3_5-2-2",
              id:this.Id,
              pid:'0',
              ivrName:this.ivrName,
              ivrType:this.ivrType,
              voiceType:this.voiceType,
              businessType:this.businessType,
              transNumber:this.transNumber,
              voiceFile:this.voiceFile,
              highSet:this.highSet?'1':'0',
              shortVoiceType:this.shortVoiceType,
              shortVoiceFile:this.shortVoiceFile,
              invalidVoiceType:this.invalidVoiceType,
              invalidVoiceFile:this.invalidVoiceFile,
              promptInterval:this.promptInterval,
              promptCount:this.promptCount,
              exceedVoiceType:this.exceedVoiceType,
              exceedVoiceFile:this.exceedVoiceFile,
              isCallExtension:this.isCallExtension?'1':'0',
              memoryType:this.memoryType,
              memoryDuration:this.memoryDuration,
              isTimeoutBusiness:this.isTimeoutBusiness?'1':'0',
              timeout:time,
            };
            flag=true;
            url='ivr/updateIvr.json';
          }
          that.$http.post(url,param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            if(flag){
              that.name=that.ivrName;
            }
            that.$Message.info("操作成功");
            that.showPageByIvrType='0',
            that.initSearch();
          });
        },
        //播放回调函数
        closeRecordfile:function(){
          this.showRecordFile=false;
        },
        //在线播放语音文件
        playVoiceFile:function (recordFile) {
          if(!recordFile){
            this.$Modal.info({
              title:'提示',
              content:"语音文件不存在"
            });
            return false;
          }
          this.showRecordFile=true;
          this.recordFile=this.baseImgURL+recordFile;
        },
        //页面加载方法
        initSearch:function () {
          this.spinShow=true;
          let that=this;
          let param={
            journalType:"null",
            menuId:"null",
            ivrId:this.Id,
            id:this.treeId
          };
          this.$http.post("ivr/selectIvrDetail.json",param) .then(function (res) {
            let result=res.data.flag;
            that.spinShow=false;
            if(result!="666"){
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            let list=res.data.obj;
            for (let i=0;i<list.length;i++){
              list[i].open=true;
              let pid=list[i].pid?list[i].pid:"0";
              let ivrType=list[i].ivrType;
              let transNumber=list[i].transNumber;
              let funcKey=list[i].funcKey;
              if(!funcKey){
                list[i].funcKey="-1";
              }
              if(ivrType=='1'){
                list[i].name=funcKey+"(下级菜单)"
              }
              if(ivrType=='2'){
                list[i].name=funcKey+"(转接电话:"+transNumber+")"
              }
              if(ivrType=='3'){
                list[i].name=funcKey+"(返回上级菜单)"
              }
              if(ivrType=='4'){
                list[i].name=funcKey+"(返回顶级菜单)"
              }
              if(pid=='0'){
                list[i].name=that.rootName;
              }
            }
            that.inspectTreeData=list;
            that.initIVRTree();
          });
        },
        editSearch:function(treeNode){
          if(treeNode.pid){
            this.pid=treeNode.pid;
          }
          if(!treeNode.pid){
            this.pid='0';
          }
          this.nodeId=treeNode.id;
          this.ivrType=treeNode.ivrType;
          this.editOrAdd='2';
          let that=this;
          let param={
            id:treeNode.id,
            pid:treeNode.pid,
            journalType:"null",
            menuId:"null"
          };
          that.$http.post("ivr/selectIvrDetail.json",param) .then(function (res) {
            let result = res.data.flag;
            if (result != "666") {
              that.$alert(res.data.msg, '提示', {
                confirmButtonText: '确定'
              });
              return false;
            }
            let list = res.data.obj[0];
            if(list.funcKey!=''){
              that.funcKey=list.funcKey;
            }
            that.memoryType=list.memoryType;
            that.voiceFile=list.voiceFile;
            that.startTransferTime=list.timeout;
            that.timeout=list.timeout;
            that.businessType=list.businessType;
            that.transNumber=list.transNumber;
            that.voiceText=list.voiceText;
            that.transInterval=list.transInterval;
            that.isSendSms=list.isSendSms=='1'?true:false;
            that.smsContent=list.smsContent;
            that.isSmsGather=list.isSmsGather=='1'?true:false;
            that.smsButtonDesc=list.smsButtonDesc;
            that.shortVoiceType=list.shortVoiceType;
            that.shortVoiceFile=list.shortVoiceFile;
            that.shortVoiceText=list.shortVoiceText;
            that.invalidVoiceType=list.invalidVoiceType;
            that.invalidVoiceFile=list.invalidVoiceFile;
            that.invalidVoiceText=list.invalidVoiceText;
            that.exceedVoiceType=list.exceedVoiceType;
            that.exceedVoiceFile=list.exceedVoiceFile;
            that.exceedVoiceText=list.exceedVoiceText;
            that.gatherVoiceType=list.gatherVoiceType;
            that.btnVoiceFile=list.gatherVoiceFile;
            that.gatherVoiceText=list.gatherVoiceText;
            that.gatherLength=list.gatherLength;
            that.isCallExtension=list.isCallExtension=='1'?true:false;
            that.isTimeoutBusiness=list.isTimeoutBusiness=='1'?true:false;
            that.memoryDuration=list.memoryDuration;
            that.promptCount=list.promptCount;
            that.promptInterval=list.promptInterval;
          });
        },
        getTreeContent:function (event,treeNode) {
          if(this.count==1){
             return false;
          }
          this.showPageByIvrType=treeNode.ivrType;
          this.demoTitle='编辑IVR语音导航';
          this.editSearch(treeNode);
          if(treeNode.level==0){
            this.showPageByIvrType="0";
            this.ivrType=treeNode.ivrType;
            return false;
          }
          if (treeNode.ivrType=='1'){
            this.showPageByIvrType="5";
          }
          let keyList=[];
          for (let i=0;i<this.inspectTreeData.length;i++){
            let pid=this.inspectTreeData[i].pid;
            let id=this.inspectTreeData[i].id;
            if (pid==treeNode.pid && treeNode.id!=id){
               keyList.push(this.inspectTreeData[i].funcKey)
             }
          };
          this.getFuncKey(keyList);
        },
        //显示添加按钮
        showAddBtn:function(treeNode){
          if(!treeNode.pid){
            this.pid='0';
          }
          this.nodeId=treeNode.id;
          let keyList=[];
          for (let i=0;i<this.inspectTreeData.length;i++){
            let pid=this.inspectTreeData[i].pid;
            if (pid==treeNode.id){
              keyList.push(this.inspectTreeData[i].funcKey)
            }
          };
          this.getFuncKey(keyList);
          if(this.keyCodeList.length==0){
            this.$alert('当前已无按键', '提示', {
              confirmButtonText: '确定'
            });
            return false;
          }
          this.count=1;
          this.showPageByIvrType='1';
          this.demoTitle='添加IVR语音导航';
          this.editOrAdd='1';
          this.showPageByIvrType='1';
          this.gatherVoiceType='1';
          this.btnVoiceFile='';
          this.smsContent='';
          this.smsButtonDesc='';
          this.gatherLength='';
          this.funcKey='0';
          this.voiceType='1';
          this.voiceFile='';
          this.promptInterval='3';
          this.promptCount='3';
          this.exceedVoiceFile='';
          this.memoryType='0';
          this.memoryDuration='';
          this.timeout="20";
          this.businessType='9';
          this.transNumber='';
          this.startTransferTime='0';
          this.spinShow=true;
          this.funcKey=this.keyCodeList[0].id;
          let that=this;
          setTimeout(function () {
            that.count=0;
            that.spinShow=false;
          },1000);
        },
        getFuncKey:function(list){
          if(list.length==0){
            this.keyCodeList=[{id:'0', name:"0"},{id:'1', name:"1"},{id:'2', name:"2"},{id:'3', name:"3"},{id:'4', name:"4"},{id:'5', name:"5"},{id:'6', name:"6"},{id:'7', name:"7"},{id:'8', name:"8"},{id:'9', name:"9"},{id:'*', name:"*"}];
            return false;
          }
          this.keyCodeList=[];
          let keyList=["0","1","2","3","4","5","6","7","8","9","*"];
          for (let i=0;i<keyList.length;i++){
            let id=keyList[i];
            if(list.toString().indexOf(id)==-1){
              this.keyCodeList.push({id:id, name:id})
            }
          }
        },
        deleteTree:function(treeId, treeNode){
          if(treeNode.pid=='0'||!treeNode.pid){
            this.$Modal.info({
              title: '提示',
              content: "顶级不可删除",
            });
            return false;
          }
          let that=this;
          this.$Modal.confirm({
            title: '提示',
            content: "是否确定删除",
            onOk: () => {
              let param={
                journalType:"CTI配置=>IVR设置=>删除ivr节点",
                menuId:"null",
                id:treeNode.id,
                pid:treeNode.pid,
              };
              that.$http.post("ivr/deleteIvr.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("删除成功");
                that.initSearch();
              });
            }
          });
        },
        //设备树初始化
        initIVRTree:function () {
          let that=this;
          let setting = {
            edit: {
              enable: true,
              removeTitle: "删除"
            },
            view: {
              dblClickExpand: false,
              showLine: true,
              selectedMulti: false,
              addHoverDom: addHoverDom,
              removeHoverDom: removeHoverDom
            },
            data: {
              simpleData: {
                enable:true,
                idKey: "id",
                pIdKey: "pid",
                rootPId: ""
              }
            },
            callback: {
              onClick: zTreeOnClick,
              beforeRemove: beforeRemove
            }
          };
          function zTreeOnClick(event,treeId,treeNode) {
            that.changeVoiceType();
            that.getTreeContent(event,treeNode);
            return false;
          };
          function beforeRemove(treeId, treeNode) {
            that.deleteTree(treeId, treeNode);
            return false;
          };
          function addHoverDom(treeId, treeNode) {
            document.getElementById(treeNode.tId+"_edit").style.display="none";
            if (treeNode.editNameFlag || $("#"+treeNode.tId+"_addButton").length>0) return;
            if (treeNode.editNameFlag || $("#"+treeNode.tId+"_voiceButton").length>0) return;
            let sObj = $("#" + treeNode.tId + "_span");
            let addStr = "";
            document.getElementById(treeNode.tId+"_remove").style.display="";
            if (treeNode.ivrType=="1"){
              addStr = "<span class='button addButton' id='" + treeNode.tId +'_addButton'+ "' title='添加' onfocus='this.blur();'></span>";
            }
            if(treeNode.voiceFile){
              addStr =addStr+"<span class='button voiceButton' id='" + treeNode.tId +'_voiceButton'+ "' title='语音' onfocus='this.blur();'></span>";
            }
            sObj.after(addStr);
            let addButton = $("#"+treeNode.tId+"_addButton");
            let voiceButton = $("#"+treeNode.tId+"_voiceButton");
            if (addButton){
                addButton.bind("click", function(){
                that.showAddBtn(treeNode);
              });
            }
            if (voiceButton){
                voiceButton.bind("click", function(){
                that.playVoiceFile(treeNode.voiceFile);
              });
            }
          };
          function removeHoverDom(treeId, treeNode) {
            $("#"+treeNode.tId+"_addButton").unbind().remove();
            $("#"+treeNode.tId+"_voiceButton").unbind().remove();
          }
          let zNodes =this.inspectTreeData;
          if (zNodes){
            $(document).ready(function(){
              $.fn.zTree.init($("#IVRTree"),setting, zNodes);//t:用于展现 zTree 的 DOM 容器,setting:zTree 的配置数据,zNodes:zTree 的节点数据
            });
          }
          let tObj=$.fn.zTree.getZTreeObj("IVRTree");
          let nodes = tObj.getNodes()[0];
          this.editSearch(nodes);
        },
        handleSuccessShortVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.shortVoiceFile=file.response.obj.absolutePath;
        },
        handleSuccessInvalidVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.invalidVoiceFile=file.response.obj.absolutePath;
        },
        handleSuccessExceedVoiceType:function (res, file) {
          this.$Modal.info({
            title:'提示',
            content:res.msg
          });
          this.exceedVoiceFile=file.response.obj.absolutePath;
        },
      },
      created(){
        this.screenHeight.height=this.mountHeight(91);
        this.demoHeight.height=this.mountHeight(180);
      },
      mounted(){
        this.initSearch();
        this.ivrName=this.name;
        this.pidName=this.rootName;
        this.pid='0';
        this.getQueue('3');
        this.ivrType=this.ivrTableType;
      }
    }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/IVRSetting.vue